import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import { PageHeaderTopRow } from "../../../components/PageHeaderTopRow";

export function ClipboardScoreAdjustmentsHeader() {
  return (
    <Stack spacing={1}>
      <PageHeaderTopRow />
      <Box sx={{ paddingX: 6, paddingBottom: 7 }}>
        <Text bold variant="h4">
          What impacts your score
        </Text>
      </Box>
    </Stack>
  );
}
